export default "__VITE_ASSET__H0z8WOgs__"